import CFS from "assets/images/CFS.svg";
import iHRP from "assets/images/iHRP.svg";
import Admin from "assets/images/admin.svg";
import eApprove from "assets/images/eApprove.svg";
import AdminReport from "assets/images/adminReport.png";
import eTendering from "assets/images/eTendering.png";

export const listApp = [
  {
    appId: 6,
    appCode: "CFS",
    appName: "CFS",
    status: 1,
    manage: 0,
    src: CFS,
    linkApp: process.env.REACT_APP_CFS_URL,
    description: "Hệ thống kế toán",
    createdAt: "05/01/2024",
    createdBy: "employee",
    updatedAt: "20/09/2024",
    updatedBy: "employee",
  },
  {
    appId: 4,
    appCode: "iHRP",
    appName: "iHRP",
    status: 1,
    manage: 0,
    src: iHRP,
    linkApp: process.env.REACT_APP_IHRP_URL,
    description: "Phần mềm quản lý nhân sự",
    createdAt: "05/01/2024",
    createdBy: "employee",
    updatedAt: "17/09/2024",
    updatedBy: "employee",
  },
  {
    appId: 1,
    appCode: "ADMIN",
    appName: "Admin Center",
    status: 1,
    manage: 1,
    src: Admin,
    linkApp: process.env.REACT_APP_ADMIN_URL,
    description: "Phần mềm hỗ trợ quản trị và phân quyền users trong hệ thống",
    createdAt: "25/12/2023",
    updatedAt: "17/09/2024",
    updatedBy: "employee",
  },
  {
    appId: 3,
    appCode: "EAP",
    appName: "eApprove",
    status: 1,
    manage: 0,
    src: eApprove,
    linkApp: process.env.REACT_APP_EAPP_URL,
    description: "Phần mềm hỗ trợ phê duyệt tập trung",
    createdAt: "03/01/2024",
    createdBy: "employee",
    updatedAt: "17/09/2024",
    updatedBy: "employee",
  },
  {
    appId: 28,
    appCode: "ADM_REPORT",
    appName: "Admin Center Report",
    status: 1,
    manage: 1,
    src: AdminReport,
    linkApp: process.env.REACT_APP_ADMIN_REPORT_URL,
    description: "",
    createdAt: "14/05/2024",
    createdBy: "employee",
    updatedAt: "10/06/2024",
    updatedBy: "employee",
  },
  {
    appId: 29,
    appCode: "ETENDERING",
    appName: "eTendering",
    status: 1,
    manage: 0,
    src: eTendering,
    linkApp:
      process.env.REACT_APP_ETENDERING_URL,
    description: "",
    createdAt: "14/10/2026",
    createdBy: "employee",
    updatedAt: "14/10/2026",
    updatedBy: "employee",
  },
];
